import { render, staticRenderFns } from "./AdminSystem.vue?vue&type=template&id=d7dcf1c4&scoped=true"
import script from "./AdminSystem.vue?vue&type=script&lang=js"
export * from "./AdminSystem.vue?vue&type=script&lang=js"
import style0 from "./AdminSystem.vue?vue&type=style&index=0&id=d7dcf1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dcf1c4",
  null
  
)

export default component.exports